// $(document).ready(function() {
//   function toggleStickyBar() {
//     $('.product-sticky-bar').toggleClass(
//       'active-product-sticky-bar',
//       $(window).scrollTop() >= 500
//     );
//   }
//   toggleStickyBar(); // Run once on page load
//   let scrollTimeout;
//   $(window).on('scroll resize', function() {
//     if (!scrollTimeout) {
//       scrollTimeout = setTimeout(function() {
//         toggleStickyBar();
//         scrollTimeout = null;
//       }, 100); // Increased timeout for better performance
//     }
//   });
// });

$(document).ready(function () {
  setTimeout(function () {
    const $previewBar = $('.product-sticky-bar');
    const $header = $('.header-section');

    if (!$previewBar.length || !$header.length) return;

    function isCompletelyOutOfView($element) {
      const rect = $element[0].getBoundingClientRect();
      const headerHeight = $header.outerHeight();
      const buffer = 40;

      const visibleAreaTop = headerHeight + buffer;
      const visibleAreaBottom = window.innerHeight - buffer;

      return rect.bottom < visibleAreaTop || rect.top > visibleAreaBottom;
    }

    function togglePreviewBar() {
     
      var $productForm = $('form[action*="/cart/add"]');
      var $addToCartButton = $productForm.find('.product-form__submit');

      if (!$addToCartButton.length) return;

      console.log("ssss ",isCompletelyOutOfView($addToCartButton), $addToCartButton);

      if (isCompletelyOutOfView($addToCartButton)) {
        $('.product-sticky-bar').addClass('active-product-sticky-bar');
      } else {
        $('.product-sticky-bar').removeClass('active-product-sticky-bar');
      }
    }

    $(window).on('scroll resize orientationchange', togglePreviewBar);
    togglePreviewBar();
  }, 500);
});


